// IframeProtector.js
'use strict';
import { connect } from 'react-redux';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import { IFRAME_MAIN_DOMAIN_WHITELIST } from '../RemoteConfigKeys.js';
import IframeProtector from '../component/IframeProtector.jsx';

const mapStateToProps = state => {
  return {
    iframeMainDomainList: getRemoteConfigData(
      state,
      IFRAME_MAIN_DOMAIN_WHITELIST
    ),
  };
};

export default connect(mapStateToProps)(IframeProtector);
